import axios from 'axios'
import { API_BASE } from '../config'

function authHeaders() {
    let token = localStorage.getItem('token');
    return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
}

export default class Admin {
    // GET /admin/access - What the viewer may do: { allowed, staff, open }. allowed is whether they may use the
    // admin panel; staff is whether they are logged in as Staff or above.
    getAccess() {
        return axios.get(`${API_BASE}/admin/access`, authHeaders()).then(x => x.data);
    }

    // GET /admin/users - Everyone who has signed up:
    // { open, viewerID, viewerLevel, levels: [{ id, name }] (lowest first),
    //   users: [{ id, username, level, joined, lastLogin, canSet, canDelete }] } where canSet lists the levels the
    // viewer may set that user to, and canDelete says whether they may delete that user's account
    getUsers() {
        return axios.get(`${API_BASE}/admin/users`, authHeaders()).then(x => x.data);
    }

    // DELETE /admin/users/:id - Delete a user's account for good: { success }
    deleteUser(userID) {
        return axios.delete(`${API_BASE}/admin/users/${encodeURIComponent(userID)}`, authHeaders()).then(x => x.data);
    }

    // PUT /admin/users/:id/level - Set a user's access level: { success, user }
    setLevel(userID, level) {
        return axios.put(`${API_BASE}/admin/users/${encodeURIComponent(userID)}/level`, { level }, authHeaders()).then(x => x.data);
    }
}
